import { Box, Container, Typography, Paper, useTheme, alpha } from '@mui/material'
import LegalHero from './LegalHero'
import { motion } from 'framer-motion'

const TermsAndConditions = () => {
  const theme = useTheme()

  return (
    <Box>
      <LegalHero
        title="Terms & Conditions"
        subtitle="Please read these terms carefully before using our services"
        lastUpdated="January 15, 2024"
      />
      
      <Container
        maxWidth="lg"
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        <Paper
          elevation={0}
          sx={{
            mt: -6,
            mb: 8,
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            bgcolor: 'white',
            position: 'relative',
            zIndex: 3,
            boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, 0.1)}`,
          }}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
            Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing and using the services of Bisworupa Inn, you agree to comply with and be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Booking and Reservations
          </Typography>
          <Typography paragraph>
            All bookings are subject to availability and the following conditions:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Valid identification (Passport/Aadhar Card/Driving License) is required at check-in
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Check-in time is 12:00 PM and check-out time is 11:00 AM
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Early check-in and late check-out are subject to availability and additional charges
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Payment Terms
          </Typography>
          <Typography paragraph>
            Our payment terms include:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Advance payment of 50% is required to confirm the booking
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Balance payment must be made at check-in
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                We accept all major credit/debit cards and UPI payments
              </Typography>
            </li>
          </ul>

          <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }}>
            Special Considerations
          </Typography>
          <Typography paragraph>
            During Rath Yatra and other major festivals:
          </Typography>
          <ul>
            <li>
              <Typography paragraph>
                Special rates and minimum stay requirements may apply
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Early booking is recommended due to high demand
              </Typography>
            </li>
            <li>
              <Typography paragraph>
                Modified cancellation policies may be in effect
              </Typography>
            </li>
          </ul>

          {/* Add more sections as needed */}
        </Paper>
      </Container>
    </Box>
  )
}

export default TermsAndConditions 